import toast from 'react-hot-toast';
import type { IRhiV2ErrorCopy } from '@/constants/rhiV2ErrorCopy';

/** One id for every notice, so a newer one replaces the last instead of stacking. */
export const RHI_V2_NOTICE_TOAST_ID = 'rhi-v2-notice';

type TRhiV2NoticeKind = 'info' | 'error' | 'loading';

/** Says why an error moved the customer to another page, or kept them waiting on this one. */
export const toastRhiV2Notice = (
  { title, body }: IRhiV2ErrorCopy,
  {
    kind = 'info',
    durationMs,
  }: { kind?: TRhiV2NoticeKind; durationMs?: number } = {},
) => {
  const message = body ? (
    <span>
      <b className="font-semibold">{title}</b>
      <br />
      {body}
    </span>
  ) : (
    title
  );
  const options = {
    id: RHI_V2_NOTICE_TOAST_ID,
    ...(durationMs && { duration: durationMs }),
  };

  if (kind === 'error') return toast.error(message, options);
  if (kind === 'loading') return toast.loading(message, options);
  return toast(message, options);
};
